/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Seat_YouInputs */



/**
* | output |
* | --- |
* | "You" |
*
* @param {Tournament_Seat_YouInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_seat_you = /** @type {((inputs?: Tournament_Seat_YouInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Seat_YouInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tú")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Você")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tu")
	return /** @type {LocalizedString} */ ("You")
});